import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { post } from "jquery";
import { postData } from "../../../utils/api";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { IDS, return_status } from "../../../utils/common";
import eye from "../../../Components/assets/icons/eye.png";
import View_address_modal from "../../common/Common_Modal/view-address-modal/View_address_modal";
import View_address_modal_Images from "../../common/Common_Modal/view-address-modal/View_address_modal_Images";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    SelectDelivery,
    getDownloadDataExcel,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [option, setOption] = useState();

  const [changeStatus, setChangeStatus] = useState();

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const [customerName, setCustomerName] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [serachProduct, setSerachProduct] = useState("");
  const [serachOrderStatus, setSearchOrderSatatus] = useState("");
  const [serachPaymentStatus, setSearchPaymentSatatus] = useState("");

  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const getDataAll = async () => {
    const response = await getData(
      `/order-return?page=${onPageChange}&per_page=${perPage}&term=${search}` +
        `&customerName=${customerName}&serachProduct=${serachProduct}` +
        `&serachReturnStatus=${
          serachOrderStatus?.value || ""
        }&serachPaymentStatus=${serachPaymentStatus}&date=${searchDate}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    customerName,
    serachProduct,
    serachOrderStatus,
    serachPaymentStatus,
    searchDate,
    onPageChange,
  ]);

  useEffect(() => {}, [serachPaymentStatus]);
  const [modalShow3, setModalShow3] = React.useState(false);
  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/order-return/${id}`);
    setChangeStatus(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };
  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/order-return/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: false,
    col14: true,
    col15: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };
  const [orderStatus, setOrderStatus] = useState({});
  const GetAllReturnStatus = async () => {
    const response = await getData("/all-return-status");

    if (response?.success) {
      setOrderStatus(await Select2Data(response?.data, "return_status_id"));
    }
  };

  useEffect(() => {
    GetAllReturnStatus();
  }, []);

  useEffect(() => {}, [selectAllChecked]);

  const handleChangeStatus = async (id) => {
    try {
      if (selectAllChecked.length === 0) {
        alert("Please select at least one row");
        return; // Exit the function early if no rows are selected
      }

      const response = await postData("/order-return/updateStatus", {
        selectedIds: selectAllChecked,
        newStatusId: id,
      });

      if (response?.success) {
        alert("Order status updated successfully:", response.data);
        getDataAll();
      }
    } catch (error) {
      console.error("Error updating order status:", error);
      // Handle errors if necessary
    }
  };

  const [deliveryBoy, setDeliveryBoy] = useState({});
  const GetAllDeliveryBoy = async () => {
    const response = await getData("/all-delivery-boy");

    if (response?.success) {
      setDeliveryBoy(await SelectDelivery(response?.data, "delivery_boy_id"));
    }
  };
  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetAllDeliveryBoy();
    GetUserData();
  }, []);

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/order-return/download",
          selectAllChecked,
          "Return Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleAssignDeliveryBoy = async (id, delivery_boy_id) => {
    try {
      // if (selectAllChecked.length === 0) {
      //   alert("Please select at least one row");
      //   return; // Exit the function early if no rows are selected
      // }

      const response = await postData("/order-return/assign", {
        selectedIds: id,
        deliveryboyId: delivery_boy_id,
      });

      if (response?.success) {
        alert("Delivery Boy Assign successfully:", response.data);
        getDataAll();
      }

      console.log("Delivery Boy Assign successfully:", response.data);
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const [modalShow2, setModalShow2] = React.useState(false);
  const [deliveryAddress, setDeliveryAddress] = React.useState(false);
  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Return Order"}
          link={"/order-managements/order/return"}
        />
        {/* return */}
        <section className="AdvanceDashboard">
          <div className="row MainRowsec me-0 ms-0">
            <section className="Tabels tab-radio tab-radio ">
              <div className="">
                {/* container */}
                <div className="row">
                  <div className="d-flex">
                    <div className="add">
                      <div className="dropdown">
                        {usertype !== "Admin" ? (
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              marginLeft: "5px",
                              backgroundColor: "green",
                            }}
                          >
                            <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            />
                            {/* <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            /> */}
                            Change Return Status{" "}
                            <img src={top} className="top ms-1" alt="" />{" "}
                          </button>
                        ) : (
                          <></>
                        )}

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          {Object.keys(orderStatus).length > 0 &&
                            Object.entries(orderStatus).map(([id, status]) => (
                              <button
                                className="dropdown-item"
                                key={id}
                                onClick={() => handleChangeStatus(status.value)}
                              >
                                {status.label}
                              </button>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 me-0 ms-0">
                    <div className="col-lg-12 col-md-12 ">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12  col-md-12 col-12">
                      <div className="row">
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div class="num me-2">
                            <Select
                              options={orderStatus}
                              placeholder="Select Order Status"
                              value={serachOrderStatus}
                              onChange={(e) => {
                                setSearchOrderSatatus(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div class="num me-2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder=" date"
                              id=""
                              value={searchDate}
                              onChange={(e) => {
                                setSearchDate(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div class="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Customer Contact"
                              id=""
                              value={customerName}
                              onChange={(e) => {
                                setCustomerName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <button
                            type="button"
                            onClick={() => {
                              setSearchPaymentSatatus("");
                              setSearchOrderSatatus("");
                              setSerachProduct("");
                              setCustomerName("");
                              setSearchDate("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="">
                            <button
                              className="btn btn-success ms-1 greenSquareBtn"
                              onClick={HandleDownload}
                            >
                              Excel Download
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="ms-2"
                              />
                            </button>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          <th>
                            <input
                              type="checkbox"
                              value="selectAll"
                              checked={
                                allChecked.length === selectAllChecked.length
                              }
                              onChange={handleChange}
                              id="selectAll"
                              className="me-1"
                            ></input>
                            Select
                          </th>
                          {visible.col1 && <th className="sr">Sr. No.</th>}
                          {visible.col2 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Invoice No.
                            </th>
                          )}
                          {visible.col3 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Customer
                            </th>
                          )}

                          {visible.col14 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Product Name
                            </th>
                          )}
                          {visible.col4 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Return Date & Time
                            </th>
                          )}
                          {visible.col5 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Order Amount
                            </th>
                          )}

                          {visible.col8 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Return Status
                            </th>
                          )}

                          {visible.col9 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Return Reason
                            </th>
                          )}

                          {visible.col9 && (
                            <th className="tax-name" style={{ width: "600px" }}>
                              Return Remark
                            </th>
                          )}

                          {visible.col13 && (
                            <th className="tax-name" style={{ width: "200px" }}>
                              Action
                            </th>
                          )}
                          {visible.col12 && (
                            <th className="tax-name" style={{ width: "200px" }}>
                              Order Details
                            </th>
                          )}
                          {visible.col8 && (
                            <th className="tax-name" style={{ width: "200px" }}>
                              Payment Proof
                            </th>
                          )}
                          {visible.col14 && (
                            <th className="tax-name" style={{ width: "200px" }}>
                              Assign Delivery Boy
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {/* {isAllow.includes(5) ? ( */}
                        {data?.data?.data?.length > 0 ? (
                          data.data.data.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    value={d?.id}
                                    name="perselected"
                                    checked={selectAllChecked.includes(d?.id)}
                                    onChange={handleChange}
                                    id="flexCheckDefault"
                                  ></input>
                                </td>
                                {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                {visible.col2 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.orders_detail?.invoice_number}
                                  </td>
                                )}
                                {visible.col3 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.orders_detail?.User?.contact_no}{" "}
                                    {`-${d?.orders_detail?.User?.first_name || "NA"}`}
                                  </td>
                                )}
                                {visible.col14 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.orders_detail?.product?.name}
                                  </td>
                                )}
                                {visible.col4 && (
                                  <td style={{ width: "600px" }}>
                                    {new Date(d?.createdAt).toLocaleString(
                                      "en-US",
                                      {
                                        month: "2-digit",
                                        day: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true, // Enable 12-hour format with AM/PM
                                      },
                                    )}
                                  </td>
                                )}
                                {visible.col5 && (
                                  <td style={{ width: "600px" }}>
                                    ₹ {d?.orders_detail?.total_amount}
                                  </td>
                                )}
                                {visible.col8 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.return_status?.name}
                                  </td>
                                )}{" "}
                                {visible.col9 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.orders_detail.return_reason?.name}
                                  </td>
                                )}
                                {visible.col9 && (
                                  <td style={{ width: "600px" }}>
                                    {d?.orders_detail.reason || "NA"}
                                  </td>
                                )}
                                {visible.col12 && (
                                  <td className="text-center">
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={() => {
                                        setModalShow2(true);
                                        setDeliveryAddress(d?.orders_detail);
                                      }}
                                    >
                                      <img
                                        src={eye}
                                        className="pen"
                                        alt=""
                                        style={{ width: "20px" }}
                                      />
                                    </button>
                                  </td>
                                )}
                                {visible.col12 && (
                                  <td className="text-center">
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={() => {
                                        setModalShow3(true);
                                        setDeliveryAddress(d);
                                      }}
                                    >
                                      <img
                                        src={eye}
                                        className="pen"
                                        alt=""
                                        style={{ width: "20px" }}
                                      />
                                    </button>
                                  </td>
                                )}
                                {visible.col14 && (
                                  <td>
                                    {usertype !== "Seller" ? (
                                      d.delivery_boy?.first_name ||
                                      "Delivery Boy Not Assigned"
                                    ) : d?.return_status_id ===
                                        return_status.ReturnRequested &&
                                      d.delivery_boy_id === null ? (
                                      <>
                                        <button
                                          className="btn btn-columns dropdown-toggle"
                                          type="button"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                          style={{ backgroundColor: "green" }}
                                        >
                                          <img
                                            src={colunms}
                                            className="columns me-2"
                                            alt=""
                                          />
                                          Assign Delivery Boy
                                          <img
                                            src={top}
                                            className="top ms-1"
                                            alt=""
                                          />
                                        </button>
                                        <div
                                          className="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton"
                                        >
                                          {Object.keys(deliveryBoy).length >
                                            0 &&
                                            Object.entries(deliveryBoy).map(
                                              ([id, status]) => (
                                                <button
                                                  className="dropdown-item"
                                                  key={id}
                                                  onClick={() =>
                                                    handleAssignDeliveryBoy(
                                                      d.id,
                                                      status.value,
                                                    )
                                                  }
                                                >
                                                  {status.label ||
                                                    `Delivery Boy ${id}`}
                                                </button>
                                              ),
                                            )}
                                        </div>
                                      </>
                                    ) : (
                                      d.delivery_boy?.first_name ||
                                      "Delivery Boy Not Assigned"
                                    )}
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              Data not available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <View_address_modal
        show={modalShow2}
        data={deliveryAddress}
        onHide={() => setModalShow2(false)}
      />

      <View_address_modal_Images
        show={modalShow3}
        data={deliveryAddress}
        onHide={() => setModalShow3(false)}
      />

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
